<template>
  <CRow>
    <CCol col="12" lg="12" style="margin-bottom: 20px;">
        <button class="btn btn-info" @click="$router.go(-1)">{{ $t("Voucher.UpdateVoucher") }}</button>
    </Ccol>
    <CCol col="12" lg="6">
      <CCard no-header>
        <CCardBody>
          <h3>
            {{ $t("Voucher.AddVoucher") }}
          </h3>
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>

            <CInput :label="$t('Voucher.Amount')" type="number" style="0.1" v-model="product.amount"></CInput>
            <CInput :label="$t('Voucher.Qte')" type="number" v-model="product.qte"></CInput>
            <label for="status">{{ $t("Voucher.State") }}</label>
            <select v-model="product.status" id="status">
              <option value="Active">{{ $t("Voucher.Active") }}</option>
              <!-- <option value="Epuisé">Epuisé</option> -->
              <option value="Arrêté">{{ $t("Voucher.Inactive") }}</option>
            </select>
          <CButton color="success" @click="store()" class="w-100">{{ $t("Button.Add") }}</CButton>
        </CCardBody>
      </CCard>
    </CCol>

    <CCol col="12" lg="6">
      <CCard no-header>
        <CCardBody>
          <span>{{ $t("Voucher.Type") }}</span><br>
          <input type="radio" name="type" id="TypeCode" value="Code" v-model="product.type" selected> <label for="TypeCode">{{ $t("Voucher.Code") }}</label><br>
          <input type="radio" name="type" id="TypeProduct" value="Product" v-model="product.type"> <label for="TypeProduct">{{ $t("Voucher.Gift") }}</label>
          <br><br>
          <div class="code" v-if="product.type=='Code'">
            <CInput :label="$t('Voucher.Voucher')" type="text" v-model="product.coupon"></CInput>
            <CButton color="dark" @click="generateRandomVoucher()">{{ $t("Voucher.Generate") }}</CButton>
            <br>
            <br>
          </div>
          <div class="product" v-else>
            <CInput :label="$t('Voucher.Appearence')" type="number" v-model="product.appearency_pourcentage"></CInput>
          </div>


        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>

  import {
    voucherService,
  } from "../../_services";
export default {
  name: 'EditUser',
  props: {
    caption: {
      type: String,
      default: 'User id'
    },
  },
  data: () => {
    return {
        product: {
          coupon: '',
          amount: null,
          type: 'Code',
          qte: null,
          appearency_pourcentage: null,
          release_date: '',
          status: 'Active'
        },
        message: '',
        dismissSecs: 7,
        dismissCountDown: 0,
        showDismissibleAlert: false,
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    },
    store() {
      if(this.product.amount>0){
        this.loader = this.$loading.show();
        let form = new FormData();
        form.append('coupon', this.product.coupon);
        form.append('amount', this.product.amount);
        form.append('type', this.product.type);
        form.append('qte', this.product.qte>1?this.product.qte:1);
        form.append('appearency_pourcentage', this.product.appearency_pourcentage?this.product.appearency_pourcentage:0);
        form.append('release_date', this.product.release_date);
        form.append('status', this.product.status);

        voucherService.create(form).then(function (data) {
          this.$toast.success('Voucher créé avec succès');
          this.message = "added successfully";
          this.showAlert();
          this.goBack();
        }.bind(this)).finally(function () {
          this.loader.hide();
        }.bind(this))
      }
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    getFilePath(file){
      file.blob = ''
      let URL = window.URL || window.webkitURL
      if (URL && URL.createObjectURL) {
        file.blob = URL.createObjectURL(file.file)
      }
      console.log(this.files.map(function(obj) { return obj.file; }));
      return file.blob;
    },
    removePhoto(file){
      this.files.forEach(function(item, i){
        if(this.files[i].name === file.name) {
          this.files.splice(i,1);
          return false;
        }
      }.bind(this));
    },
    generateRandomVoucher(){
      var result           = '';
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for ( var i = 0; i < 15; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      this.product.coupon = result;
    }
  },
  mounted(){
  }
}

</script>
<style>
  .product-preview {
    width: 150px;
    height: 150px;
    float: left;
    background-position: center;
    background-size: 80% 100%;
    background-repeat: no-repeat;
    margin: 5px;
  }
  select{
    width: 100%;
    height: 35px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    padding-left: 10px;
    border-radius: 5px;
    color: #888;
  }
</style>